'use client'

import { useDispatch } from 'react-redux'
import { setCurrency } from '../redux/reducers/invoiceSlice'
import { useEffect, useState } from 'react'

const allCurrencies = Intl.supportedValuesOf('currency')

export default function CurrencySelector() {
  const [selectedCurrency, setSelectedCurrency] = useState('USD')
  const [loading, setLoading] = useState(true)

  const dispatch = useDispatch()

  useEffect(() => {
    async function fetchCountry() {
      try {
        const res = await fetch('https://ipapi.co/json/')
        const data = await res.json()
        const country = data.country || 'US'

        // Dynamically import locale-currency ONLY in the browser
        const { default: localeCurrency } = await import('locale-currency')

        let currency = localeCurrency.getCurrency(country)
        if (!currency || !allCurrencies.includes(currency)) {
          currency = 'USD'
        }

        sessionStorage.setItem('currency', currency)
        setSelectedCurrency(currency)
        // set value in redux store
        dispatch(setCurrency(currency))
      } catch (error) {
        console.error(error)
        setSelectedCurrency('USD')
      } finally {
        setLoading(false)
      }
    }

    // Use cache if available
    const cached = sessionStorage.getItem('currency')
    if (cached) {
      setSelectedCurrency(cached)
      setLoading(false)
      // set value in redux store
      dispatch(setCurrency(cached))
    } else {
      fetchCountry()
    }
  }, [])

  return (
    <select
      id="invoice-currency"
      name="invoice-currency"
      value={selectedCurrency}
      disabled={loading}
      onChange={(e) => {
        setSelectedCurrency(e.target.value)
        sessionStorage.setItem('currency', e.target.value)
        dispatch(setCurrency(e.target.value))
      }}
      className="w-28 px-2 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
    >
      {loading ? (
        <option>Loading...</option>
      ) : (
        allCurrencies.map((currency) => (
          <option key={currency} value={currency}>
            {currency}
          </option>
        ))
      )}
    </select>
  )
}
